import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AdminRoutingModule } from './admin-routing.module';
import { CreateAdminComponent } from './create-admin.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReCaptchaModule } from 'angular-recaptcha3';
import constantURL from 'src/app/shared/constantURL';

@NgModule({
  declarations: [CreateAdminComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AdminRoutingModule,
    SharedModule,
    ReCaptchaModule.forRoot({
      invisible: {
        sitekey: constantURL.RECAPTCHA_KEY,
      },
      normal: {
        sitekey: constantURL.RECAPTCHA_KEY,
      },
      language: 'en',
    }),
  ],
})
export class AdminModule {}
